import { RootState } from "../../../app/store";

export const selectModalId = (state: RootState) => state.modal.modalId;
